module.exports = __webpack_public_path__ + "img/02-02-img-04.ca3740ef.png";